import React from "react";
import Tick from "./../../../assets/icons/lsq_tick.svg";
import { taskStatusMap } from "../../../utils/helper";
import "./TastStatus.css";
const TastStatus = ({ event }) => {
  const dateToCheck = new Date(event?.auditDetails?.endDateLocalTime);
  const currentDate = new Date();
  let status = taskStatusMap?.[event?.status?.status];
  if (status === "pending" && dateToCheck < currentDate) status = "overdue";
  return (
    <div className={`task-status ng_p_2_r ${status}`}>
      {status === "overdue" ? status : ""}
      {status === "completed" && (
        <img src={Tick} alt="icon" style={{ width: "12px", height: "12px" }} />
      )}
    </div>
  );
};

export default TastStatus;
